import React, { useEffect, useMemo, useState } from "react";

import { Container, Grid } from "@mui/material";
import Report from '../components/Report'
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  getDocs,
} from "firebase/firestore";
import { fireDB } from "../config";
import { Abc } from "@mui/icons-material";
import * as IoIcons from "react-icons/io";
import * as FaIcons from "react-icons/fa";
import DashboardCard from "../components/DashboardCard";
export default function Reports() {
  const [orders, setOrders] = useState();
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [coupons, setCoupons] = useState([]);

  const countValue = useMemo(() => {
    var holder = {};
    if (orders?.length) {
      orders?.forEach((t) => {
        t?.productsToBuy?.forEach((d) => {
          if (holder.hasOwnProperty(d.name)) {
            holder[d.name] = holder[d.name] + d.quantity;
          } else {
            holder[d.name] = d.quantity;
          }
        });
      });
      var obj2 = [];
      for (var prop in holder) {
        obj2.push({ name: prop, value: holder[prop] });
      }

      return obj2;
    } else {
      return [];
    }
  }, [orders]);
  const countCoupon = useMemo(() => {
    var holder = 0;
    let coupon = 0;
    if (coupons?.length) {
      coupons?.forEach((t) => {
        holder += parseInt(t?.users?.length ? t?.users?.length : 0);
        coupon += parseInt(t?.status ? 1 : 1);
      });

      return { user: holder, coupon };
    } else {
      return [];
    }
  }, [coupons]);

  useEffect(() => {
    getData();
  }, []);
  async function getData() {
    const q = query(
      collection(fireDB, "orders"),
      orderBy("pickUptimeandDate", "desc")
    );

    onSnapshot(q, (querySnapshot) => {
      const cities = [];
      querySnapshot.forEach((doc) => {
        cities.push({ ...doc.data(), id: doc.id });
      });
      setOrders(cities);
    });
    let user = [];
    const userQ = collection(fireDB, "users");
    const usersSnapshot = await getDocs(userQ);
    usersSnapshot.forEach((doc) => {
      user.push({ ...doc.data(), id: doc.id });
    });
    setUsers(user);
    let product = [];
    const productQ = collection(fireDB, "products");
    const productsSnapshot = await getDocs(productQ);
    productsSnapshot.forEach((doc) => {
      product.push({ ...doc.data(), id: doc.id });
    });
    setProducts(product);
    let coupon = [];
    const couponQ = collection(fireDB, "coupons");
    const couponsSnapshot = await getDocs(couponQ);
    couponsSnapshot.forEach((doc) => {
      coupon.push({ ...doc.data(), id: doc.id });
    });
    setCoupons(coupon);
  }

  return (
    <Container xs={{ my: 5 }}>
      <Grid container spacing={3}>
        <Grid xs={12} sm={6} md={3} item>
          <DashboardCard
            icon={<FaIcons.FaUsers color="#E4780E" size={32} />}
            title="Users"
            value={users ? users.length : 0}
            color="#E4780E"
          />
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          <DashboardCard
            icon={<FaIcons.FaHamburger color="#E4780E" size={35} />}
            title="Products"
            value={products ? products.length : 0}
            color="#E4780E"
          />
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          <DashboardCard
            icon={<IoIcons.IoMdCart color="#E4780E" size={35} />}
            title="Orders"
            value={orders ? orders.length : 0}
            color="#E4780E"
          />
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          <DashboardCard
            icon={<Abc sx={{ fontSize: 40, color: "#E4780E" }} />}
            title="Coupon"
            value={coupons ? coupons.length : 0}
            color="#E4780E"
          />
        </Grid>
      </Grid>
      {countValue?.length && <Report countValue={countValue} />}
    </Container>
  );
}

